import React        from 'react';
import { Redirect } from 'react-router-dom';
import Module       from './Module';
import ModuleList   from './ModuleList';

export const ModuleConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path      : '/module/:view_type/:module_id',
            component : Module,
            permission: { component_name: 'module', permission_type: 'view_type' },
        },
        {
            path      : '/module/list',
            component : ModuleList,
            permission: { component_name: 'module', permission_type: 'list' },
        },
        {
            path      : '/module/:view_type/',
            component : Module,
            permission: { component_name: 'module', permission_type: 'view_type' },
        },
        {
            path      : '/module',
            component : () => <Redirect to="/module/list" />,
            permission: { component_name: 'module', permission_type: 'list' },
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/module/ModuleConfig.js